module.exports = __webpack_public_path__ + "img/VPS-khandevane.195363c.jpg";